import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Container } from 'web-ui-components/lib/global/layout';
import withContent from '../../../containers/withContent';
import { withScrollTop } from '../../../containers/withScrollTop';

import { PaymentName } from '../common/PaymentName';
import ImportedPaymentTable from '../common/ImportedPaymentTable';
import { BacsUploadHeader as FPSUploadHeader, BacsUploadFooter as FPSUploadFooter } from '../common';
import { getPage } from '../../../states/page/selectors';
import { getBatchName, getBatchTotalLimitExceeded } from '../../../states/batch/selectors';
import { hasApiCallInProgress } from '../../../states/api/selectors';
import { getPageTotal } from '../../../states/importedPaymentList/selector';
import { getAccountsForAddPayee } from '../../../states/accounts/selectors';

import { setBackPage } from '../../../states/page/actions';
import { updateBatchName, toggleBatch } from '../../../states/batch/actions';
import { submitImportedPaymentRequestForFpsOrChaps } from '../../../managePayee/states/action';
import { clearPayments } from '../../../states/payments/actions';

import styles from '../common/styles';
import { formatAmount } from '../../../helpers/fieldHelpers';
import { batchNameMaxLength, TYPE_CHAPS } from '../../../config';
import pageContent, { contentPropTypes } from './ImportedPaymentsPage.content';
import UnSavedWarningModal from '../../../sharedComponents/UnSavedWarningModal/UnSavedWarningModal';
import { accountsForAddPayeePropTypes } from '../../../payees/states/addPayee/propTypes';
import PaymentLimitsModal from '../../../fasterPayments/components/Payments/PaymentLimitsModal';
import { ChapsPaymentLimitsModal } from '../../../chaps/components/ChapsPayments/ChapsPaymentLimitsModal';

const mapState = (state) => ({
	currentPage: getPage(state),
	total: formatAmount(getPageTotal(state)),
	importedPaymentFileName: getBatchName(state),
	hasApiCallInProgress: hasApiCallInProgress(state),
	isBatchLimitExceeded: getBatchTotalLimitExceeded(state),
	accountsForAddPayee: getAccountsForAddPayee(state),
});
const mapDispatch = (dispatch) => ({
	clearPayments: () => dispatch(clearPayments()),
	toggleBatch: (value) => dispatch(toggleBatch(value)),
	setBackPage: (currentPage) => dispatch(setBackPage(currentPage)),
	handlePaymentNameChange: (name) => dispatch(updateBatchName({ name })),
	submitImportedPaymentRequestForFpsOrChaps: (details) => dispatch(submitImportedPaymentRequestForFpsOrChaps(details)),
});
class ImportedPaymentsPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			hasMissingFromAccounts: false,
			showUnsavedWarningModal: false,
		};
		this.handleContinue = this.handleContinue.bind(this);
		this.handleCancel = this.handleCancel.bind(this);
	}
	componentWillMount() {
		this.props.handlePaymentInReview(true);
	}
	componentDidMount() {
		const { handleDisplayFullwidth = () => {}, toggleBatch = () => {}, clearPayments = () => {} } = this.props;
		clearPayments();
		handleDisplayFullwidth();
		toggleBatch(true);
	}
	componentWillUnmount() {
		this.props.handlePaymentInReview(false);
	}
	handleCancel() {
		this.setState({
			showUnsavedWarningModal: true,
		});
	}
	handleContinue() {
		const { handleContinue, handleBack, type, submitImportedPaymentRequestForFpsOrChaps, accountsForAddPayee } =
			this.props;

		const details = {
			accountsForAddPayee,
			handleContinue,
			handleBack,
			type,
		};

		submitImportedPaymentRequestForFpsOrChaps(details);
	}
	render() {
		const {
			content,
			content: {
				title,
				description,
				batchPaymentNameLabel,
				batchPaymentNameLabelSubText,
				paymentNameRequirements,
				paymentNamePopperText,
				maxLimitExceededMessage,
			},
			importedPaymentFileName,
			handlePaymentNameChange,
			hasApiCallInProgress,
			handleBack,
			total,
			isBatchLimitExceeded,
			type,
		} = this.props;

		const { showUnsavedWarningModal } = this.state;

		return (
			<div className="c-o-payee-list--from-state">
				{showUnsavedWarningModal && (
					<UnSavedWarningModal
						handleClose={() => {
							this.setState({ showUnsavedWarningModal: false });
						}}
						isModalOpen
						handleBack={handleBack}
						contentKey="importPaymentsContent"
					/>
				)}
				<FPSUploadHeader title={title} description={description} />
				<Container className={styles.payments__container}>
					<ImportedPaymentTable total={total} content={content} />
				</Container>
				{isBatchLimitExceeded && (
					<p className="u-color-utility-error" id="batch-Limit-exceeded-msg">
						{maxLimitExceededMessage}
					</p>
				)}
				<div className="u-margin-top-2">
					<PaymentName
						id="paymentName"
						paymentName={importedPaymentFileName}
						maxLength={batchNameMaxLength}
						onBlur={handlePaymentNameChange}
						description={paymentNameRequirements}
						label={batchPaymentNameLabel}
						labelSubText={batchPaymentNameLabelSubText}
						paymentNamePopperText={paymentNamePopperText}
					/>
				</div>
				<FPSUploadFooter
					isBatchLimitExceeded={isBatchLimitExceeded}
					hasApiCallInProgress={hasApiCallInProgress}
					handleContinue={this.handleContinue}
					handleCancel={this.handleCancel}
				/>
				{type === TYPE_CHAPS ? <ChapsPaymentLimitsModal /> : <PaymentLimitsModal />}
			</div>
		);
	}
}

ImportedPaymentsPage.propTypes = {
	accountsForAddPayee: PropTypes.arrayOf(PropTypes.shape(accountsForAddPayeePropTypes)).isRequired,
	hasApiCallInProgress: PropTypes.bool.isRequired,
	content: PropTypes.shape(contentPropTypes),
	importedPaymentFileName: PropTypes.string,
	handleDisplayFullwidth: PropTypes.func,
	handleBack: PropTypes.func.isRequired,
	handlePaymentInReview: PropTypes.func.isRequired,
	handlePaymentNameChange: PropTypes.func,
	submitImportedPaymentRequestForFpsOrChaps: PropTypes.func.isRequired,
	handleContinue: PropTypes.func,
	toggleBatch: PropTypes.func,
	total: PropTypes.string.isRequired,
	type: PropTypes.string.isRequired,
	clearPayments: PropTypes.func,
	isBatchLimitExceeded: PropTypes.bool,
};

export const connectWrapper = compose(
	connect(mapState, mapDispatch),
	withContent({ content: pageContent }),
	withScrollTop
)(ImportedPaymentsPage);
